import React from 'react';
import ReactDOM from 'react-dom/client';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';
import TheFirstTake from './TheFirstTake';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  //  <React.StrictMode> // react-youtubeが耐えられない アンマウント時にYouTubeプレイヤーのインスタンスが用意できず、destroyできない
  <BrowserRouter>
    <Routes>
      <Route path="/tft" element={<TheFirstTake />} />
      <Route path="/" element={<Link to="/tft">tft</Link>} />
      <Route path="*" element={<h1>404 Not Found.</h1>} />
    </Routes>
  </BrowserRouter>
  //  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
